/* DSL Image-search — upload + send to /apps/dsl/image-search endpoint, redirect to results */
(function(){
  document.addEventListener("change", function(e){
    if (!e.target.matches("[data-image-search] input[type=file]")) return;
    var f = e.target.files[0]; if (!f) return;
    if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Foto wordt geanalyseerd...", variant: "info"});
    var fd = new FormData(); fd.append("image", f);
    fetch("/apps/dsl/image-search", {method: "POST", body: fd}).then(function(r){return r.json();}).then(function(d){
      if (d.query) location.href = "/search?q=" + encodeURIComponent(d.query);
    }).catch(function(){
      if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Image search niet beschikbaar — probeer text-search.", variant: "error"});
    });
    if (window.DSL_AB) window.DSL_AB.track("image_search_attempt", {});
  });
})();